import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { LetDirective } from '@ngrx/component';
import { Store } from '@ngrx/store';

import { selectLanguage } from '@ninety/platform/state';
import { BillingStateActions } from '@ninety/platform/state/app-global/billing/billing-state.actions';
import { TerraIconModule } from '@ninety/terra';
import { NinetyCMModule } from '@ninety/ui/core';
import { FilterBarActions } from '@ninety/web/pages/shared/layouts';

@Component({
  standalone: true,
  imports: [TerraIconModule, NinetyCMModule, LetDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'ninety-headlines-tiered-page',
  template: `<ninety-cm-tiered-page *ngrxLet="data$ as data">
    <div headline>Seamless Communication Across Your Teams</div>
    <div description>
      The {{ data.language.headline.items }} tool lets you easily share news, access archives, and manage announcements.
      Keep everyone informed and aligned, wherever they work.
    </div>
    <button ninety-cm-button (click)="onExplorePlansClick()">
      <terra-icon icon="lightning" variant="fill" />
      Explore Essentials Plan
    </button>
    <a href="https://help.ninety.io/introduction-to-headlines" rel="external" target="_blank"
      >Learn more about {{ data.language.headline.items }}</a
    >
  </ninety-cm-tiered-page>`,
})
export class HeadlinesTieredPageComponent implements OnInit {
  private readonly store = inject(Store);

  data$ = {
    language: this.store.select(selectLanguage),
  };

  ngOnInit(): void {
    this.store.dispatch(FilterBarActions.hide());
  }

  onExplorePlansClick(): void {
    this.store.dispatch(BillingStateActions.openPricingPlansModal());
  }
}
